import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';

const styles = {
  fullWidth: {
    width: '100%'
  }
};

class ParticipantEmail extends Component {
  constructor(props) {
    super(props);
    this.hasHelperText = this.hasHelperText.bind(this);
    this.hasError = this.hasError.bind(this);
  }

  hasHelperText() {
    if (this.props.validateEmail()) {
      return 'Please enter a valid email.';
    } else if (this.props.duplicateEmail) {
      return 'Email already in use.';
    } else if (this.props.isSendersEmail) {
      return "Can't save as your email";
    } else {
      return 'Edit participant email';
    }
  }

  hasError() {
    if (
      this.props.duplicateEmail ||
      this.props.validateEmail() ||
      this.props.isSendersEmail
    ) {
      return true;
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.props.isEditing ? (
          <TextField
            onChange={this.props.handleEmailChange}
            error={this.hasError()}
            defaultValue={this.props.email && this.props.hasGeneratedEmail()}
            email={this.props.email}
            type="email"
            name="email"
            helperText={this.hasHelperText()}
            className={classes.fullWidth}
          />
        ) : (
          <div>
            <Typography noWrap>
              {this.props.hasGeneratedEmail() && this.props.email}
            </Typography>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(ParticipantEmail);



// WEBPACK FOOTER //
// ./src/components/ParticipantEmail.js